import React, { useState } from 'react';
import { Tabs, Tab } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import SystemLogsDetails from './SystemLogsDetail';
import SearchEmailBreach from '../../Components/SearchEmailBreach/SearchEmailBreach';
import EmailBreachalluser from '../../Components/EmailBreachalluser/EmailBreachalluser';
import EmailBreachHistoryUserEmail from '../../Components/EmailBreachHistoryUserEmail/EmailBreachHistoryUserEmail'

const EmailBreach = () => {
    const { id } = useParams(); // Ensure the route contains a parameter named 'id'

    const { t } = useTranslation();
    const [key, setKey] = useState("SearchEmailBreach");
    // State variables



    return (
        <div className="p-4">

            <div className="pageTitle mb-4">{t('EmailBreach')}</div>

            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
            >

                <Tab eventKey="SearchEmailBreach" title={t('SearchEmailBreach')}>
                    <div>
                        <SearchEmailBreach />
                    </div>
                </Tab>
                <Tab eventKey="EmailBreachalluser" title={t('EmailBreachalluser')}>
                    <div>
                        <EmailBreachalluser />
                    </div>
                </Tab>
                <Tab eventKey="Checkhistoryforusersbyemail" title={t('Checkhistoryforusersbyemail')}>
                    <div>
                        <EmailBreachHistoryUserEmail />
                    </div>
                </Tab>
            </Tabs>

        </div>
    );
};

export default EmailBreach;